/* ------------------------------ */
/* Get breakpoints from css  */

/* ------------------------------ */

window.getBreakpoint = function getBreakpoint() {
    'use strict';

    // set some vars
    var style = null,
        breakpoint = [],
        breakpoints = [],
        i;

    /* added to font-family as IE8 doesn't recognise style property of content when it not on a pseudo element
     * reason for not using a pseudo element is because we can't grab the styles of pseudo elements at all in IE8
     * use the js function getComputedStyle() to grab the styles of pseudo elements in newer browsers */
    style = $('.lessVars').css('font-family');

    // split breakpoints into array
    style = style.replace(/\,\s+/g, ',').split(',');

    // split each breakpoint into array
    $.each(style, function () {
        // remove px from value and split each value into breakpoint name and number
        breakpoint = this.replace(': ', ':').replace('px', '').replace('\'', '').replace('\"', '').split(':');

        // build array with breakpoint name as key and number as value
        for (i = 0; i < breakpoint.length; i++) {
            breakpoints[breakpoint[0]] = breakpoint[1];
        }
    });

    // return breakpoints
    return breakpoints;
}